<template>
  <div class="mmap-container" :class="{hidden, 'mt-3': !hidden}">
    <div style="position: relative">
      <div class="cmap-container" ref="container">
        <yandex-map
            :coords="[62.60535465026992, 109.02637708195046]"
            @map-was-initialized="mapLoaded"
            :zoom="3"
            :controls="[]"
            :options="{suppressMapOpenBlock: true}"
        >
          <ymap-marker
              v-for="(point) in points"
              :coords="point"
              :key="'map-marker'+point[0]+point[1]"
              :marker-id="'map-marker'+point[0]+point[1]"
              :icon="markerIcon"
          />
        </yandex-map>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "app-map",
  props:{
    items:{
      type: [Object, Array],
      default: () => []
    },
    hidden:{
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    markerIcon: {
      layout: 'default#imageWithContent',
      imageHref: require('@/assets/icons/baloon.svg'),
      imageSize: [15, 15],
      imageOffset: [0, 0],
    },
    map: null,
  }),
  methods:{
    mapLoaded(map){
      let offset = 130
      this.map = map;
      this.map.controls.add('zoomControl', {
        position: {
          top: (offset)+'px',
          left: 'auto',
          right: '10px',
          bottom: 'auto'
        },
        size: 'small',
      })
      this.map.controls.add('geolocationControl', {
        position: {
          top: (offset+70)+'px',
          left: 'auto',
          right: '10px',
          bottom: 'auto'
        },
        size: 'small',
      })
    }
  },
  computed:{
    points(){
      return this.items.map((item)=>item.location).filter((item) => item != '[]' && item.length == 2)
    }
  },
}
</script>

<style>
.ymap-container {
  height: 100%;
}
.cmap-container {
  height: 400px;
  overflow: hidden;
  position: absolute;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0px 0px 3px 0px #E5E5EA;
}
.mmap-container{
  overflow: hidden;
  height: 400px;
  max-height: 400px;
  transition: max-height .2s ease-in-out, margin-top .2s linear;
}
.mmap-container.hidden{
  max-height: 0;
}
</style>
